import { IsString, IsUUID, Length, IsInt, IsDate, IsNotEmpty, MaxLength, IsOptional, ValidateIf } from "class-validator";

export enum MaritalStatus {
  SINGLE = "SINGLE",
  MARRIED = "MARRIED",
  DIVORCED = "DIVORCED",
  WIDOWED = "WIDOWED",
  SEPARATED = "SEPARATED",
}

export class UserProfessionalInfo {
	@IsInt({ message: "Escolha uma das opções" })
	profession: number;

	@MaxLength(100)
  @IsNotEmpty()
  graduationSchool: string;

  @IsDate()
  graduationDate: Date;

	@MaxLength(100)
  @IsNotEmpty()
  graduationState: string;

	@MaxLength(100)
  @IsNotEmpty()
  professionalDocumentNumber: string;

  @IsUUID()
  professionalDocumentUrl: string;

	@IsOptional()
  @IsUUID()
	professionalDocumentAttachmentUrl: string;

	@IsOptional()
  @IsUUID()
  diplomaUrl: string;

	@IsOptional()
	@MaxLength(100) // Exemplo: 170.33259.50-4
  pisNumber: string;

	@IsOptional()
  @IsUUID()
  pisUrl: string;

  @IsOptional()
	@MaxLength(100)
  cnsNumber: string;

	@IsOptional()
  @IsUUID()
  cnsUrl: string;

	@IsOptional()
  @IsInt({ message: "Escolha uma das opções" })
  specialty: number;

	@ValidateIf(professionalInfo => !!professionalInfo.specialty)
	@IsNotEmpty()
  @IsUUID()
  specialtyUrl: string;

	@IsOptional()
	@MaxLength(2000)
  previousExperiences: string;

	@IsOptional()
  @IsUUID()
  curriculumUrl: string;
}
